import { useBlockRegistry } from "./useBlockRegistry";

export const useRenderer = () => {
  const { resolveBlockComponent } = useBlockRegistry();
  const renderContent = (content) => {
    return resolveBlockComponent(content.componentId ?? content.type);
  };

  return {
    resolveComponentType: (type) => resolveBlockComponent(type),
    renderContent,
  };
};